<template>
  <section
    class="md:w-full md:h-full md:absolute md:bg-grey-bg md:flex items-center md:justify-center"
  >
    <div
      class="md:w-full md:max-w-sm md:bg-white md:rounded-lg md:border md:px-6 custom-min-height"
    >
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheGreyWrapper',
};
</script>

<style lang="scss" scoped>
.custom-min-height {
  min-height: 400px;
  overflow-y: auto;

  @media (min-width: 768px) {
    max-height: 80vh;
  }
}
</style>
